<script lang="ts">
  import { default as InvoicesIndex } from "@retailer/svelte/Payments/Index.svelte";
  import { params } from "@roxi/routify";

</script>

<InvoicesIndex selectedTab={$params.selectedTab} />
